module.exports = __webpack_public_path__ + "img/lanzi.c38b78a4.png";